export default __webpack_public_path__ + "5d70e5f5d3b1377e603efa0ee097e953.png";